import React from 'react';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import MobileDetect from 'mobile-detect';
import isCrawlers from 'lib/utils/isCrawlers';

import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import { MembershipView } from 'views/membership-module/MembershipView';
import { HydrationWrapper } from 'views/common/components';
import { serverFetch } from 'lib/utils/serverFetch';
import { API } from 'lib/config/axios';
import getLocalizedUrl from 'lib/utils/getLocalizedUrl';

const MembershipPage = (props) => {
  const { serverData } = props;

  return (
    <>
      <HydrationWrapper>
        <MembershipView serverData={serverData} />
      </HydrationWrapper>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const { locale, query, req } = ctx;

  const hreflangData = generateHreflang(
    PATHS.motorcycleClub.slug(query.slug).url,
    locale,
  );

  const userAgent = req.headers['user-agent'];
  const ssrRender = isCrawlers(userAgent);
  let layoutData = null;
  let serverData = null;
  let serverError = null;

  if (ssrRender) {
    const [layoutRes, pageRes] = await Promise.all([
      serverFetch(ctx, API.layout),
      serverFetch(ctx, API.membership.slug.replace('{slug}', query.slug)),
    ]);
    if (layoutRes.success) {
      layoutData = layoutRes.data;
    }
    if (pageRes.success) {
      serverData = pageRes.data;
    } else {
      switch (pageRes.error.response.status) {
        case 302:
          return {
            redirect: {
              destination: getLocalizedUrl(
                PATHS.motorcycleClub.slug(pageRes.error.response.data.new_slug)
                  .url,
                ctx.locale,
              ),
              permanent: true,
            },
          };
        default:
          serverError = {
            statusCode: pageRes.error.response.status,
          };
      }
    }
  }
  if (serverError) {
    ctx.res.statusCode = serverError.statusCode;
  }
  let deviceType;
  const md = new MobileDetect(userAgent);
  if (md.tablet()) {
    deviceType = 'tablet';
  } else if (md.mobile()) {
    deviceType = 'mobile';
  } else {
    deviceType = 'desktop';
  }

  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'fe_er_membership_page',
        'fe_er_common_map_groups',
        'fe_er_common_main_widget_dialog',
        'fe_er_common_main_widget',
        'fe_er_common_map_with_groups',
        'fe_er_common_membership_faq',
        'fe_er_membership_landing_page',
        'fe_er_common_location_card',
        'fe_er_common_motorcycle_rentals',
        'fe_er_common_make_carousel',
      ])),
      hreflangData,
      layoutData,
      serverData,
      serverError,
      ssrRender,
      deviceType,
    },
  };
}
export default MembershipPage;
